module.exports = new __parcel__URL__("ImportInProgressIllustration.5721ebc1.svg").toString();